import React from 'react';

let SelecTableros = (props) => {
  let {selectTab, tab} = props;
  return (
    <select onChange={selectTab(tab)}>
      <option>Elige</option>
      {(tab !== undefined) && (tab !== false)
      ? Object.keys(tab).map((key) => {
          return (
            <option
              style={{backgroundColor: "#4454BB"}} 
              key={tab[key][0].id}
              value={tab[key][0].id}
              index={key}>
              {tab[key][0].name}
            </option>
          )
        })
      : null
    }
    </select>
  )


}

export default SelecTableros;


// WEBPACK FOOTER //
// ./src/Components/AddCards/SelecTablero.js